// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.embed-code {
  box-sizing: border-box;
  display: block;
  padding: 16px;
  margin: 1em 0;
  background: #f8f9fc;
  border: solid 1px #dde3f0;
  border-radius: 3px;
}

.embed-code:before {
  content: 'Embed Code';
  display: block;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #505762;
  margin-bottom: 4px;
}

.embed-code:after {
  content: 'Allow user to select and copy embed codes to post it on their website (e.g. share our interactive inforgraphics)';
  display: block;
  font-size: 12px;
  line-height: 16px;
  color: #97a1b3;
  margin-top: 4px;
}

.embed-code__content {
  box-sizing: border-box;
  display: block;
  font-size: 14px;
  line-height: 20px;
  padding: 7px;
  margin: 0;
  background: #fff;
  border-radius: 3px;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}

.ck .embed-code__content.ck-editor__nested-editable {
  border: solid 1px #dde3f0;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/embed-code/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2HAA2H;EAC3H,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iGAAiG;AACnG;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".embed-code {\n  box-sizing: border-box;\n  display: block;\n  padding: 16px;\n  margin: 1em 0;\n  background: #f8f9fc;\n  border: solid 1px #dde3f0;\n  border-radius: 3px;\n}\n\n.embed-code:before {\n  content: 'Embed Code';\n  display: block;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #505762;\n  margin-bottom: 4px;\n}\n\n.embed-code:after {\n  content: 'Allow user to select and copy embed codes to post it on their website (e.g. share our interactive inforgraphics)';\n  display: block;\n  font-size: 12px;\n  line-height: 16px;\n  color: #97a1b3;\n  margin-top: 4px;\n}\n\n.embed-code__content {\n  box-sizing: border-box;\n  display: block;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 7px;\n  margin: 0;\n  background: #fff;\n  border-radius: 3px;\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\n}\n\n.ck .embed-code__content.ck-editor__nested-editable {\n  border: solid 1px #dde3f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
